const facultyData = [
  {
    id: 1,
    name: "김병완",
    role: "미디어콘텐츠학부 / 학부장",
    img: "faculty/faculty1.jpg",
    phone: "043-299-8595",
    email: "smart@seowon.ac.kr",
    message: `"새로운 변화의 중심, 미디어콘텐츠학부 졸업생 여러분의 저력을 믿습니다."

서원대학교 문화예술체육대학 미디어콘텐츠학부장 김병완 교수입니다.
미디어콘텐츠학부 졸업작품 전시회를 진심으로 축하합니다.

미디어콘텐츠학부 졸업작품 전시회를 통해 여러 회사 대표 및 미디어콘텐츠전문가 분들께 인사드리게 됨을 기쁘게 생각합니다. 
우리 미디어콘텐츠학부는 미래산업의 핵심 인재, 창의융합형 미디어콘텐츠전문가 양성을 목표로 현장에서 요구하는 전문가가 되기 위해 지난 4년간 열심히 가르치고 학생들 또한 최선을 다해 배워왔습니다.

여러 힘든 환경적 상황에서도 이번 졸업작품 전시회는 'MAKE RE : REWRITE 각자의 시선으로 다시쓰는 이야기'라는 컨셉을 중심으로 완성도 있는 작품을 만들기 위해 뜬눈 지새며 최선의 노력과 도전정신을 발휘하였습니다. 
그리고 이 모든 것들이 졸업생 여러분 스스로 '과정이 곧 결과'임을 경험하고 모두 하나 되어 졸업작품 전시회를 멋지게 준비하였습니다.

오늘과 같은 결과물을 제작할 수 있도록 성심성의껏 열정을 갖고 지도해 주신 교수님, 사랑과 믿음으로 든든한 후원자가 되어주신 학부모님, 물심양면으로 도움과 지도를 해주신 산업체 인사들을 비롯한 관계자 모든 분에게 미디어콘텐츠학부를 대표하여 감사 인사드립니다.

졸업생 여러분!
이제 곧 정든 제1자연관을 떠나 4년간 우리가 지녔던 긍정과 우리가 함께했던 열정을 앞으로도 살아가는 내내 따뜻하게 간직하며 살아가 주시길 바랍니다.

여러분은 최고였습니다.
고맙습니다. 그리고 정말 수고 많았습니다.
`
  },

    {
    id: 2,
    name: "이병권",
    role: "미디어콘텐츠학부 / 멀티전공주임",
    img: "faculty/faculty2.jpg",
    phone: "043-299-8957",
    email: "sonic747@seowon.ac.kr",
    message: `“남부럽지 않은 삶”

"남부럽지 않은 삶"이란, 누군가를 따라가는 삶이 아니라 자신만의 속도와 방식으로 세상을 만들어가는 삶입니다.

여러분은 지난 4년간 수많은 시도와 협업 속에서 콘텐츠가 세상을 바꾸는 힘을 몸소 경험했습니다.

AI와 미디어가 빠르게 진화하는 시대, 진짜 경쟁력은 ‘창의적인 사고’와 ‘따뜻한 감성’입니다. 트렌드를 읽되, 거기에 휩쓸리지 않고 스스로의 이야기를 만들어가는 사람이 되어 주세요.

때로는 도전이 어렵게 느껴질지라도, 그 과정 속에 성장과 가능성이 숨어 있습니다. 여러분의 여정이 누군가의 영감이 되길 바라며, 자신만의 빛으로 세상을 비추는 멋진 크리에이터로 성장하길 진심으로 응원합니다.
`
  },

    {
    id: 3,
    name: "김금영",
    role: "미디어콘텐츠학부 / 영상전공주임",
    img: "faculty/faculty3.jpg",
    phone: "043-299-8598",
    email: "ashley@seowon.ac.kr",
    message: `“축하합니다, 그리고 감사합니다.”

여러분 인생의 가장 빛나는 4년을 함께 할 수 있어 감사했습니다. 

그동안 수많은 도전과 고민, 그리고 웃음과 눈물이 있었겠지요. 하지만 그 모든 시간이 여러분을 한층 단단하고 멋진 사람으로 성장시켰을 것이라 믿습니다. 

이제 세상이라는 무대에서 여러분만의 색깔로 마음껏 빛나시길 바랍니다.  여러분의 앞날에 늘 설렘과 용기가 함께하길 바랍니다. 

사랑하고 축복합니다~
`
  },

    {
    id: 4,
    name: "이희만",
    role: "미디어콘텐츠학부 / 지도교수",
    img: "faculty/faculty4.jpg",
    phone: "043-299-8591",
    email: "hlee@seowon.ac.kr",  
    message: `“끝임없는 도전, 끝없는 성장” 

졸업작품은 여러분의 열정과 노력이 피워낸 아름다운 결실입니다. 수많은 도전과 시행착오 속에서도 끝까지 포기하지 않고 스스로의 길을 만들어온 여러분의 걸음에 진심으로 박수를 보냅니다. 

끊임없이 발전하고 변화하는 IT 분야에서 현재의 지식과 능력에 안주한다는 것은 곧 퇴보를 의미합니다. 항상 새로운 기술을 배우고 변화에 적응하며 자신을 발전시키는 노력을 멈추지 않길 바랍니다. 졸업작품 전시회라는 소중한 경험이 앞으로의 여정에서 든든한 힘이 되어 더 큰 꿈으로 이어지길 진심으로 응원합니다.
`
  },

    {
    id: 5,
    name: "최흥렬",
    role: "미디어콘텐츠학부 / 지도교수",
    img: "faculty/faculty5.jpg",
    phone: "043-299-8592",
    email: "hychoi@seowon.ac.kr",  
    message: `“사랑하는 나의 제자들의 해피엔딩을 믿습니다” 

대학은 의미 있고 가치 있는 인생을 살 수 있게 하는 좋은 토양을 만드는 곳입니다.
대학 생활을 통해서 여러분들이 얻은 것이 단지 기술이나 지식만이 아닙니다.
여러분들은 학문을 한 것입니다.

학문이란 어려울 때 이겨낼 수 있고, 고통스러울 때 인내할 수 있고, 노력하면 미래가 열린다는 것을 알 수 있게 해주고, 유혹에 흔들리지 않고 참된 인간이 될 수 있게 해주는 것입니다.
앞으로 여러분들의 미래에 '학문의 힘'이 발휘될 수 있기를 바랍니다.

자신감과 자부심을 갖고 더 넓은 세상으로 힘차고 즐겁게 나아가십시오.
여러분들은 충분히 그런 자격이 있습니다.
`
  },

    {
    id: 6,
    name: "유해영",
    role: "미디어콘텐츠학부 / 지도교수",
    img: "faculty/faculty6.jpg",
    phone: "043-299-8596",
    email: "karma21@seowon.ac.kr",   
    message: `“여러분의 앞날을 응원합니다.”

오늘은 여러분이 지난 시간 동안 흘린 땀과 열정의 결실을 세상에 선보이는 뜻깊은 날입니다. 그동안 수많은 시도와 도전, 그리고 시행착오 속에서도 포기하지 않고 창의적인 결과물을 완성해 낸 여러분의 노력에 깊은 박수를 보냅니다.

여러분이 이제 막 사회에 첫발을 내딛으려는 지금, 우리는 국내외로 결코 녹록지 않은 경제 상황을 마주하고 있습니다. 그 어느 때보다 쌀쌀한 현실의 공기를 느끼며, '과연 잘 해낼 수 있을까' 하는 염려와 무게감을 동시에 느끼고 있으리라 생각합니다.

그러나 이러한 위기가 꼭 나쁜 것만은 아닙니다. '위기는 곧 기회'라는 말이 있듯이, 그동안 성실하게 준비해온 여러분에게는 이 변화의 시대가 오히려 더 큰 도약의 발판이 되어줄 것입니다.세상 그 누구도 실패를 위해 노력하지는 않습니다. 그러나 성공의 이면에는 언제나 크고 작은 실패가 함께합니다. 그 실패의 경험이야말로 여러분을 더욱 단단하게 만들고, 새로운 가능성의 문을 열어주는 소중한 자양분이 될 것입니다.

보이는 것이 전부가 아니라는 사실을 잊지 마십시오.

‘성공’보다는 ‘성장’을 목표로 자신을 믿고 묵묵히 나아가는 사람에게는 언제나 행운과 기회가 찾아옵니다. 이제 사회라는 더 큰 무대에서 당당히 여러분의 이야기를 펼쳐 나가길 바랍니다. 여러분의 앞날에 무한한 가능성과 빛나는 행운이 함께하길 진심으로 응원합니다.
`
  },

    {
    id: 7,
    name: "김명미",
    role: "미디어콘텐츠학부 / 초빙교수",
    img: "faculty/faculty7.jpg",
    phone: "043-299-8599",
    email: "design125@sewon.ac.kr",  
    message: `노력을 이기는 재능은 없고 노력을 외면하는 결과는 없습니다.

또한 실패를 많이 해본 사람은 많이 해본 사람으로 어려움이 있어도 이겨낼 수 있는 강인한 사람이 됩니다.

넘어짐을 두려워하지 말고 강인한 사회인이 되길 바랍니다
`
  },

    {
    id: 8,
    name: "조한주",
    role: "미디어콘텐츠학부 / 겸임교수",
    img: "faculty/faculty8.jpg",
    phone: "043-299-8590",
    email: "orkdman@gmail.com",  
    message: `삶은 끊임없는 선택의 연속입니다. 어느 순간이고 후회가 없는 선택은 없습니다. 

어려운순간 힘든선택을 해야 할 때는 늘 초심을 생각하며 후회가 적은 선택을 하시기를 바랍니다.  
`
  },
  
    {
    id: 9,
    name: "이가하",
    role: "미디어콘텐츠학부 / 겸임교수",
    img: "faculty/faculty9.jpg",
    phone: "043-299-8590",
    email: "kahalee@naver.com",    
    message: `졸업을 진심으로 축하드립니다. 그동안 학교에서 보낸 시간 동안 여러분이 쌓아온 노력과 고민이 한 점 한 점의 작품으로 피어나, 오늘의 전시를 통해 결실을 맺게 되어 매우 뜻깊습니다. 함께한 시간은 길지 않았지만, 수업 속에서 보여준 여러분의 성실함과 진지한 태도에서 큰 인상을 받았습니다.

학교에서의 경험과 배움이 앞으로의 길을 든든히 지탱해줄 거라 믿습니다.이제는 스스로의 길을 자신 있게 만들어가길 바랍니다. 새로운 환경에서 마주할 도전들 또한 성장의 밑거름이 될 것입니다.

자신이 걸어온 과정을 믿고, 그 속에서 얻은 통찰과 열정을 잃지 않기를 바랍니다.

대학에서의 시간이 여러분 각자의 여정에 소중한 출발점이 되기를 바라며, 앞으로 펼쳐질 길 위에 늘 좋은 인연과 행운이 함께하길 진심으로 응원합니다.
`
  },  
  
];



export default facultyData;
